import { Component } from '@angular/core';
import {BaseComponent} from "@base/component/BaseComponent";
import {ServiceBagService} from "@base/component/ServiceBag";
import {ScreenService} from "@core/framework/screen.service";
import {BaseState} from "@base/entities/BaseEntities";

class State extends BaseState {
    Menu = [];
}

@Component({
    selector: 'app-demo-cards',
    templateUrl: './demo-cards.component.html',
    styleUrls: ['../../styles/demo-styles.scss']
})
export class DemoCardsComponent extends BaseComponent<State> {

    constructor(A: ServiceBagService, public screen: ScreenService) {
        super(A, 'DemoCardsComponent', State);
    }

    protected override OnInitComponent() {

        this.State.Menu = [
            {
                label: 'Edit',
                icon: 'dx-icon dx-edit',
                command: () => {
                    console.log('edit clicked');
                }
            },
            {
                label: 'Delete',
                icon: 'dx-icon dx-trash',
                command: () => {
                    console.log('delete clicked')
                }
            }
        ];
    }
}
